import React, { useEffect, useState } from "react";
import "./HolidayList.css";

function HolidayList() {
  const [holidays, setHolidays] = useState([]);

  useEffect(() => {
    fetch("https://hrms.urbango.co.in/server/index.php?endpoint=holidays")
      .then((res) => res.json())
      .then((data) => setHolidays(data))
      .catch(() => setHolidays([]));
  }, []);

  return (
    <div className="holiday-card">
      <h2 className="holiday-title">Holiday List</h2>
      <table className="holiday-table">
        <thead>
          <tr>
            <th className="holiday-th">Date</th>
            <th className="holiday-th">Day</th>
            <th className="holiday-th">Holiday</th>
          </tr>
        </thead>
        <tbody>
          {holidays.map((h, index) => (
            <tr key={index} className="holiday-row">
              <td className="holiday-td">{h.date}</td>
              <td className="holiday-td">{h.day}</td>
              <td className="holiday-td">{h.holidayName}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default HolidayList;
